import { Button } from "@productlane/ui"

import { NOTIFICATIONS_COPY as copy } from "./copy"

// One quiet line, like Linear; the detail pane carries the artwork.
export function NotificationListEmpty({
	title,
	onShowAll,
}: {
	title: string
	onShowAll?: () => void
}) {
	return (
		<div className="flex h-full flex-col items-center justify-center gap-3 px-6 pb-12 text-center">
			<p className="text-sm text-gray-500 dark:text-gray-400">{title}</p>
			{onShowAll && (
				<Button variant="ghost" onClick={onShowAll}>
					{copy.empty.showAll}
				</Button>
			)}
		</div>
	)
}
